import styled from "styled-components";

// Flex-контейнер для списка и окна
export const ChatContainer = styled.div`
  display: flex;
  height: 100%;
  background: #f5f7fa;
  border-radius: 8px;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;


